import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import CartBody from "./elements/CartBody";
import Timeline from "./Timeline";
import Tyre from "./elements/Tyre";
import QuotationForm from "./elements/QuotationForm";
import {
  batteryQuotation,
  normalQuotation,
  tyreQuotation,
  workshopPurchase,
} from "../../lib/config";
import { connect } from "react-redux";
import Battery from "./elements/Battery";
import QuoteThankYou from "./elements/QuoteThankYou";
import {
  fetchAllCartAddons,
  setCartJourney,
  setCartStage,
  setSelectedQuotationForm,
  setShowMobileIstand,
} from "../../redux/actions/cartAction";
import { useRouter } from "next/router";
import { isMobile } from "react-device-detect";

const Cart = ({
  id,
  apiData,
  getModel,
  globalData,
  getCarBrandModal,
  getWorkshopsProductCategory,
  getWorkshopsJourneyVariant,
  cart,
  getWorkshopFilterMapTwo,
  getService,
  getAddon,
  workData,
  serviceData,
  setServiceData,
  setShow,
  show,
  getWorkshopFilterMap,
  fetchAllCartAddons,
  setCartJourney,
  setShowMobileIstand,
  setSelectedQuotationForm,
  setCartStage
}) => {
  const router = useRouter();

  useEffect(() => {
    if (cart.jobItems.length > 0) {
      let jobs = cart.jobItems.map((job) => ({
        WorkshopId: job.WorkshopId,
        JourneyVariantId: job.JourneyVariantId,
        JourneyVariantItemId: job.JourneyVariantItemId,
        JobId: job.JobId,
        JobItemId: job.JobItemId,
      }));
      fetchAllCartAddons(jobs, globalData.carData?.modelId);
    }
  }, [cart.jobItems]);

  useEffect(() => {
    if (cart.journeyType == normalQuotation && !isMobile) {
      setCartJourney(workshopPurchase);
    }
    if (cart.workshop && isMobile) {
      setCartStage(2)
    }
    return () => {
      setShowMobileIstand(false);
      setSelectedQuotationForm(null);
    };
  }, []);

  return (
    <div
      className={cart.workshop && cart?.showMobileIsland ? "cart-view  _cart_island--op cart-island-on-mobile-without-header" : "cart-view-empty-workshop cart-view _cart_island--op cart-island-on-mobile-without-header"}
      // className="cart-view-empty-workshop _cart_island--op"
      style={{ height: "calc(100vh - 114px)" }}
    >
      {cart.journeyType === tyreQuotation && !cart.tyreQuotation.isProceed && (
        <Tyre
          getModel={getModel}
          apiData={apiData}
          globalData={globalData}
          getCarBrandModal={getCarBrandModal}
        />
      )}
      {(cart.journeyType === tyreQuotation ||
        cart.journeyType === batteryQuotation ||
        cart.journeyType === normalQuotation) &&
        (cart.tyreQuotation.isProceed ||
          cart.batteryQuotation.isProceed ||
          cart.journeyType === normalQuotation) && <QuotationForm id={id} />}
      {cart.journeyType === batteryQuotation &&
        !cart.batteryQuotation.isProceed && (
          <Battery
            getModel={getModel}
            apiData={apiData}
            globalData={globalData}
            getCarBrandModal={getCarBrandModal}
          />
        )}
      <div className="sidebar-crt-skin">
        {cart.journeyType === workshopPurchase && <Timeline />}
        {cart.journeyType === workshopPurchase && (
          <CartBody
            id={id}
            getWorkshopsProductCategory={getWorkshopsProductCategory}
            getWorkshopsJourneyVariant={getWorkshopsJourneyVariant}
            getWorkshopFilterMapTwo={getWorkshopFilterMapTwo}
            getService={getService}
            getAddon={getAddon}
            workData={workData}
            serviceData={serviceData}
            setServiceData={setServiceData}
            setShow={setShow}
            show={show}
            apiData={apiData}
            selection={true}
            getWorkshopFilterMap={getWorkshopFilterMap}
            globalData={globalData}
          />
        )}
      </div>
      {cart.journeyType === "thankYou" && <QuoteThankYou />}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    cart: state.cart,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAllCartAddons: (jobs, carModel) => {
      dispatch(fetchAllCartAddons(jobs, carModel));
    },
    setCartJourney: (stage) => {
      dispatch(setCartJourney(stage));
    },
    setCartStage: (stage) => {
      dispatch(setCartStage(stage));
    },
    setShowMobileIstand: (flag) => {
      dispatch(setShowMobileIstand(flag));
    },
    setSelectedQuotationForm: (item) => {
      dispatch(setSelectedQuotationForm(item));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
